import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import { onGoBack } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';

class ViewInventoryScanSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIds: []
    };
  }

  _onSelectAll = (isSelected) => {
    try {
      const { scanSessionData, onSelectedSession } = this.props;
      let selectedIds = [];
      if (isSelected === false) {
        Object.keys(scanSessionData).map((session) => {
          scanSessionData[session].map(({ SessionID }) => {
            selectedIds.push(SessionID);
          });
        });
      } else {
        selectedIds = [];
      }
      onSelectedSession(selectedIds);
      this.setState({ selectedIds });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectedIds = (sessionId) => {
    try {
      const { selectedIds } = this.state;
      const { onSelectedSession } = this.props;
      if (selectedIds.indexOf(sessionId) > -1) {
        selectedIds.splice(selectedIds.indexOf(sessionId), 1);
      } else {
        selectedIds.push(sessionId);
      }
      onSelectedSession(selectedIds);
      this.setState({ selectedIds });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _goBack = () => {
    try {
      const { goBack, setSingleScanSession } = this.props;
      setSingleScanSession({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  render() {
    const { selectedIds } = this.state;
    const { scanSessionData } = this.props;
    return (
      <section className="list-section resizer-class manage-session">
        <section className="case-details-section pb-3 pt-2">
          <div className="container">
            <div className="row gx-2">
              {
                !_.isEmpty(scanSessionData) && Object.keys(scanSessionData).map((session) => (
                  scanSessionData[session].map((item, key) => (
                    <div className="col-12 mb-2 ms-wrap ss-group-block-bottom" key={key}>
                      <div className="form-check form-check-right d-flex flex-row-reverse justify-content-between gap-5">
                        <input
                          className="form-check-input" type="checkbox"
                          value=""
                          id={item.SessionID}
                          onClick={() => this._onSelectedIds(item.SessionID)}
                          checked={selectedIds.indexOf(item.SessionID) > -1}
                          data-checkboxes="mygroup"
                        />
                        <label className="form-check-label" htmlFor={item.SessionID}>
                          {item.SessionName} {item.SessionName !== '' ? '<br />' : ''} {item.SessionID}
                        </label>
                      </div>
                    </div>
                  ))
                ))
              }
              <section className="sets-footer-section fixed-bottom resizer-class">
                <div className="row gx-2">
                  <div className="col-4 col-md-4" />
                  <div className="col-4 col-md-4">
                    <Link
                      type="checkbox"
                      className="btn btn-theme-alt d-block"
                      onClick={() => this._onSelectAll(
                        selectedIds.length === Object.keys(scanSessionData).length
                      )}
                      checked={selectedIds.length === Object.keys(scanSessionData).length
                        && Object.keys(scanSessionData).length > 0}
                      id="selectedAll"
                      disabled={scanSessionData.length === 0}
                    >{selectedIds.length === Object.keys(scanSessionData).length ? 'Deselect All' : 'Select All'}
                    </Link>
                  </div>
                  <div className="col-4 col-md-4" />
                </div>
              </section>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default ViewInventoryScanSession;
